module.exports = __webpack_public_path__ + "img/brand8-head.b1f56b33.png";